/// <amd-module name="typeahead/features/ScrollInputToTop" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {ElementFocusedMessage} from "typeahead/core/message/ElementFocusedMessage";
import {InputValueEditedMessage} from "typeahead/core/message/InputValueEditedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] =  [
    {
        clients: ["PackageLandingPage", "FlightsLandingPage", "HotelsLandingPage", "CarsLandingPage"],
    },
    {
        clients: ["Homepage", "AWSHomepage"],
        lobs: ["FLIGHTS", "HOTELS", "CARS", "PACKAGES"],
    },
];

export class ScrollInputToTop implements IExperimentalFeature {
    private isScrollTopOn: boolean = false;

    constructor() {
        TypeaheadMessage.subscribe(
            ElementFocusedMessage.getTopic(), (topic: string, message: ElementFocusedMessage) => {
                this.isScrollTopOn = false;
                if (TypeaheadUtils.isWithinMobileBreakpoint() &&
                        ExecutionHelper.shouldExecute(message.getContext(), configuration)) {
                    this.scrollTop($("#" + message.getDomElementId()));
                    this.isScrollTopOn = true;
                }
            },
        );

        TypeaheadMessage.subscribe(
            InputValueEditedMessage.getTopic(), (topic: string, message: InputValueEditedMessage) => {
                if (this.isScrollTopOn) {
                    this.scrollTop($("#" + message.getDomElementId()));
                }
            },
        );
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private scrollTop($input): void {
        const page = $("body");
        const stopScrollEvents = "wheel touchmove";

        const zoom = document.documentElement.clientWidth / window.innerWidth;
        if (zoom > 1) {
            // known web issue: inconsistent offsets while zoomed
            return;
        }

        // Default
        let destination = $input.offset().top - 13;

        const anchorElement = $input.siblings(".label");
        if (anchorElement.length > 0) {
            // As per Mingle #2796 - "Show field label with 13px padding from top"
            destination = anchorElement.offset().top - 7; // 6px to accommodate label text top padding
        }

        const currentOffset = page.scrollTop();

        // if it's close enough, don't bother scrolling
        if (Math.abs(currentOffset - destination) < 6.5) {
            return;
        }

        // stop animation if user tries to move page manually
        page.on(stopScrollEvents, () => {
            page.off(stopScrollEvents);
            page.stop();
        });

        page.animate({
            scrollTop: destination,
        }, 300);
    }
}
